import React from "react";
import PropTypes from "prop-types";
import { StoryPage } from "./story";

class StoryPagePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.collectStoryData();
  }

  collectStoryData() {
    global.addEventListener("message", event => {
      if (event.data.story) {
        this.setState({
          story: event.data.story,
          relatedStories: Array(4).fill({ story: event.data.story })
        });
      }
    });
  }

  render() {
    if (!this.state.story) return <div />;
    return <StoryPage data={this.state} config={this.props.config} />;
  }
}

StoryPagePreview.propTypes = {
  config: PropTypes.any
};

export { StoryPagePreview };
